module.exports = __webpack_public_path__ + "img/whiteTick-2.d6dbec95.svg";